module.exports = __webpack_public_path__ + "static/img/kajskjasa232562.e3c1b87a.jpg";